import { useState } from "react";

import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Link,
	Typography,
} from "@mui/material";
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';


export default function OfferDialog() {
	const [open, setOpen] = useState(false);

	return (
		<>
			<Link
				component="button"
				type="button"
				underline="hover"
				onClick={(event) => {
					event.preventDefault();
					event.stopPropagation();

					setOpen(true);
				}}
				sx={{
					font: "inherit",
					verticalAlign: "baseline",
					cursor: "pointer",
				}}
			>
				договором-офертой
			</Link>

			<Dialog
				open={open}
				onClose={() => setOpen(false)}
				fullWidth
				maxWidth="md"
				scroll="paper"
			>
				<DialogTitle>
					Договор-оферта на размещение рекламы в ООО "ТриАнда"
				</DialogTitle>

				<DialogContent dividers>
					<Box
						sx={{
							"& p": {
								mb: 1.5,
							},

							"& h6": {
								mt: 2.5,
								mb: 1.5,
								fontWeight: 700,
							},

							"& h6:first-of-type": {
								mt: 0,
							},
						}}
					>
						<Typography variant="h6">
							1. Предмет Договора
						</Typography>

						<Typography>
							1.1. Исполнитель по заданию Рекламодателя принимает на себя обязательства по изготовлению и (или) размещению рекламно-информационных материалов в СМИ г.Новолукомля - телепрограмме «ТриАнда» на условиях, предусмотренных настоящим Договором, а Рекламодатель обязуется принять и оплатить оказанные услуги.
						</Typography>

						<Typography>
							График (сроки, периодичность, формат подачи рекламного материала и другие характеристики) выхода в эфир размещаемых рекламных материалов определяются письменными заявками Рекламодателя или посредством оформления заявки через сайт www.trianda.by, которые будут являться приложениями к настоящему Договору.
						</Typography>


						<Typography variant="h6">
							2. Права и обязанности сторон
						</Typography>

						<Typography>
							2.1. Рекламодатель обязуется:
						</Typography>

						<Typography>
							2.1.1. Предоставить рекламную информацию, необходимую для изготовления и (или) размещения рекламных материалов, не позднее 3 (трех) дней до даты заявленного им срока размещения.
						</Typography>

						<Typography>
							Предоставляемая информация должна соответствовать требованиям действующего законодательства, в том числе, Законам Республики Беларусь «О рекламе», «О средствах массовой информации», «О противодействии монополистической деятельности и развитии конкуренции».
						</Typography>

						<Typography>
							2.1.2. Предоставлять Исполнителю копии документов, подтверждающие право Рекламодателя на осуществление деятельности, при рекламировании видов деятельности, подлежащих обязательному лицензированию, сертификации - копии лицензий, сертификатов.
						</Typography>

						<Typography>
							2.1.3. Обеспечить достоверность рекламной информации, предоставляемой Исполнителю, и ее соответствие законодательству РБ.
						</Typography>

						<Typography>
							2.1.4. Принимать на себя претензии и иски третьих лиц, связанных с несоответствием рекламной информации, действительности и с несанкционированным использованием в рекламной информации торговых марок, товарных знаков, фирменных знаков, наименований фирм и за свой счет урегулировать их.
						</Typography>

						<Typography>
							2.1.5. Своевременно произвести оплату оказываемых услуг в соответствии с условиями настоящего договора.
						</Typography>

						<Typography>
							2.1.6. Рекламодатель несет полную ответственность за точность и правильность помещаемой информации и немедленно в письменном виде извещает Исполнителя о любых изменениях в своем положении, наименовании, адресе и номенклатуре услуг.
						</Typography>

						<Typography>
							2.2. Исполнитель обязуется:
						</Typography>

						<Typography>
							2.2.1. Разместить рекламные материалы после оплаты услуг, в порядке, предусмотренном п. 3 настоящего Договора.
						</Typography>

						<Typography>
							2.2.2. Обеспечить своевременную и беспрепятственную передачу по каналам кабельной сети г. Новолукомля рекламных материалов в телепрограмме «ТриАнда» в полном объеме и точных сроках, указанных в заявке Рекламодателя.
						</Typography>

						<Typography>
							2.2.3. В случае технической невозможности осуществления в срок передачи по каналам кабельной сети г. Новолукомля рекламных материалов, уведомить об этом Рекламодателя не позднее, чем за 24 часа до начала заявленного Рекламодателем срока, и компенсировать задержку последующими равными по стоимости рекламными мероприятиями, предварительно согласовав дату с Рекламодателем.
						</Typography>

						<Typography>
							2.2.4. По требованию Рекламодателя выдать эфирную справку о трансляции его рекламных материалов.
						</Typography>

						<Typography>
							2.3. Рекламодатель имеет право:
						</Typography>

						<Typography>
							2.3.1. Предоставить Исполнителю для размещения в телепрограмме «ТриАнда» также рекламные материалы собственного изготовления, в том числе видеоролики с указанием в заявке на размещение тайм-код, хронометража и название рекламных роликов.
						</Typography>

						<Typography>
							2.3.2. Контролировать процесс выхода в эфир рекламных материалов на предмет соответствия их полноты и объема условиям, указанным в заявке на изготовление и размещение рекламы, не вмешиваясь в деятельность Исполнителя.
						</Typography>

						<Typography>
							2.4. Исполнитель имеет право:
						</Typography>

						<Typography>
							2.4.1. Не приступать к изготовлению рекламных материалов и (или) их размещению, если предоставленная Рекламодателем информация: не соответствует моральным и этическим нормам; противоречит действующему законодательству; может нанести ущерб его репутации.
						</Typography>

						<Typography>
							2.4.2. Об отказе в изготовлении и (или) размещении рекламных материалов по перечисленным основаниям Исполнитель уведомляет Рекламодателя и предлагает заменить отклоненные материалы новыми.
						</Typography>

						<Typography>
							2.4.2. Если Рекламодатель, несмотря на своевременное и обоснованное предупреждение Исполнителя, не устранит обстоятельства, препятствующие изготовлению и размещению рекламных материалов, в одностороннем порядке расторгнуть Договор и потребовать полного возмещения убытков.
						</Typography>


						<Typography variant="h6">
							3. Порядок расчетов
						</Typography>

						<Typography>
							3.1. Стоимость и порядок оплаты оказываемых услуг, определенных в п.1.1. настоящего Договора, производится согласно действующим тарифам на момент выхода в эфир, утвержденным Исполнителем с учетом предоставляемых скидок.
						</Typography>

						<Typography>
							3.2. Оплата стоимости услуг производится Рекламодателем за 3 (три) рабочих дня до момента начала размещения рекламного материала на основании выставленного Исполнителем счета-фактуры.
						</Typography>


						<Typography variant="h6">
							4. Ответственность сторон
						</Typography>

						<Typography>
							4.1. Стороны несут ответственность в случае нарушения договорных обязательств в соответствии с законодательством РБ и настоящим Договором.
						</Typography>

						<Typography>
							4.2. Исполнитель не несет ответственности за ошибки в представленной Рекламодателем рекламной информации.
						</Typography>

						<Typography>
							В случае если по вине Исполнителя в процессе изготовления и размещении рекламных материалов допущены: - технический брак, - не соблюден объем оплаченного срока размещения: - допущены фактические ошибки в изложении информации Исполнитель за свой счет устраняет недостатки при проведении рекламных мероприятий.
						</Typography>

						<Typography>
							4.3. В случае нарушения условий оплаты со стороны Рекламодателя Исполнитель вправе не преступать либо приостановить изготовление и размещение рекламного материала до получения оплаты.
						</Typography>


						<Typography variant="h6">
							5. Другие положения (только для юрлиц)
						</Typography>

						<Typography>
							5.1. По факту оказания услуг Стороны составляют и подписывают двусторонний Акт приемки-сдачи оказанных услуг.
						</Typography>

						<Typography>
							5.2. По окончании календарного месяца не позднее 3-х рабочих дней Исполнитель предоставляет Рекламодателю для подписания Акт приемки-сдачи оказанных услуг.
						</Typography>


						<Typography variant="h6">
							6. Срок действия, изменение и расторжение Договора
						</Typography>

						<Typography>
							6.1. Договор вступает в силу с момента подписания и действует до исполнения условий Сторонами.
						</Typography>

						<Typography>
							6.2. По истечении срока действия Договор может быть продлен Сторонами по взаимному соглашению.
						</Typography>

						<Typography>
							6.3. Все изменения и дополнения к настоящему Договору оформляются в виде приложений, которые подписываются Сторонами и вступают в силу с момента их подписания.
						</Typography>

						<Typography>
							6.4. Ни одна из Сторон не вправе передавать свои права и обязанности по настоящему Договору третьим лицам без согласия на то другой Стороны.
						</Typography>

						<Typography>
							6.5. В случае возникновения обстоятельств, препятствующих выполнению обязательств по Договору, Стороны обязуются известить друг друга в течение 24 часов по факсимильной связи или в письменной форме.
						</Typography>

						<Typography>
							6.6. Стороны вправе по взаимному согласию расторгнуть Договор до истечения срока его действия. Договор считается расторгнутым по истечении 10 дней с момента уведомления инициатором расторжения Договора другой Стороны о намерении расторгнуть Договор.
						</Typography>

						<Typography>
							6.7. В случае досрочного расторжение Договора Стороны обязаны исполнить все обязательства по настоящему Договору, возникшие у них до момента расторжения.
						</Typography>


						<Typography variant="h6">
							7. Разрешение споров
						</Typography>

						<Typography>
							7.1. Все споры и разногласия по настоящему Договору должны решаться в соответствии с действующим законодательством Республики Беларусь.
						</Typography>
					</Box>
				</DialogContent>

				<DialogActions>
					<Button
						onClick={() => setOpen(false)}
						variant="contained"
						startIcon={<FavoriteBorderIcon />}
					>
						Всё понятно!
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}